<div class="extra-results-display">
  <div
    *ngIf="
      isRowEnabled('treasuryDepoRate') &&
      markUpExpanded &&
      ('treasuryDepoRate' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row center-text"
  >
    {{ pricedLeg?.extraResults?.treasuryDepoRate | percent: '1.2-2' }}
  </div>
  <div
    *ngIf="
      isRowEnabled('treasuryInterest') &&
      markUpExpanded &&
      ('treasuryInterest' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row center-text"
  >
    <ng-container
      *ngIf="
        pricedLeg?.extraResults?.treasuryInterest !== null &&
        pricedLeg?.extraResults?.treasuryInterest !== undefined &&
        pricedLeg?.extraResults?.treasuryInterest !== ''
      "
    >
      {{ depositCurrency }}
      {{ pricedLeg?.extraResults?.treasuryInterest | number: '1.0-0' }}
    </ng-container>
  </div>
  <div
    *ngIf="
      isRowEnabled('dcdInterest') &&
      markUpExpanded &&
      ('dcdInterest' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row center-text"
  >
    <ng-container
      *ngIf="
        pricedLeg?.extraResults?.dcdInterest !== null &&
        pricedLeg?.extraResults?.dcdInterest !== undefined &&
        pricedLeg?.extraResults?.dcdInterest !== ''
      "
    >
      {{ depositCurrency }}
      {{ pricedLeg?.extraResults?.dcdInterest | number: '1.0-0' }}
    </ng-container>
  </div>
  <div
    *ngIf="
      isRowEnabled('dayCount') &&
      markUpExpanded &&
      ('dayCount' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row center-text"
  >
    {{ pricedLeg?.extraResults?.dayCount | number: '1.2-2' }}
  </div>
  <div
    *ngIf="
      isRowEnabled('pv01') &&
      markUpExpanded &&
      ('pv01' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.extraResults?.pv01 != null &&
        pricedLeg?.extraResults?.pv01 !== ''
      "
    >
      {{ depositCurrency }}
      {{ pricedLeg?.extraResults?.pv01 | number: '1.0-0' }}
    </div>
  </div>
  <div
    *ngIf="
      isRowEnabled('fairRate') &&
      markUpExpanded &&
      ('fairRate' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div class="center-text">
      {{ pricedLeg?.extraResults?.fairRate | percent: '1.4-4' }}
    </div>
  </div>
  <div
    *ngIf="
      isRowEnabled('fairRateForStrike') &&
      markUpExpanded &&
      ('fairRateForStrike' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row center-text"
  >
    {{ pricedLeg?.extraResults?.fairRateForStrike | percent: '1.2-2' }}
  </div>
  <div
    *ngIf="
      isRowEnabled('fairStrikeForRate') &&
      markUpExpanded &&
      ('fairStrikeForRate' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row center-text"
  >
    <ng-container
      *ngIf="
        pricedLeg?.extraResults?.fairStrikeForRate !== null &&
        pricedLeg?.extraResults?.fairStrikeForRate !== undefined &&
        pricedLeg?.extraResults?.fairStrikeForRate !== ''
      "
    >
      {{ currencyPair }}
      {{ pricedLeg?.extraResults?.fairStrikeForRate | number: '1.2-4' }}
    </ng-container>
  </div>

  <div
    *ngIf="
      isRowEnabled('firstSpotDelta') &&
      markUpExpanded &&
      ('firstSpotDelta' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        ('firstSpotDelta' | includedIn: extraResults) &&
        pricedLeg?.pricing?.spotDeltas &&
        (((pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency !== '' &&
          (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency) !== undefined &&
          (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency) !== null
      "
    >
      {{ baseCurrency }}
      {{ (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency | number: '1.0-0' }}
    </div>
  </div>

  <div
    *ngIf="
      isRowEnabled('secondSpotDelta') &&
      markUpExpanded &&
      ('secondSpotDelta' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        ('secondSpotDelta' | includedIn: extraResults) &&
        (pricedLeg?.pricing?.spotDeltas)[1]?.baseCurrency !== '' &&
        (pricedLeg?.pricing?.spotDeltas)[1]?.baseCurrency !== null &&
        (pricedLeg?.pricing?.spotDeltas)[1]?.baseCurrency !== undefined
      "
    >
      {{ baseCurrency }}
      {{ (pricedLeg?.pricing?.spotDeltas)[1]?.baseCurrency | number: '1.0-0' }}
    </div>
  </div>

  <div
    *ngIf="
      isRowEnabled('firstVega') &&
      markUpExpanded &&
      ('firstVega' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        ('firstVega' | includedIn: extraResults) &&
        pricedLeg?.pricing?.vegas &&
        (pricedLeg?.pricing?.vegas)[0] &&
        (pricedLeg?.pricing?.vegas)[0]?.baseCurrency !== '' &&
        (pricedLeg?.pricing?.vegas)[0]?.baseCurrency !== undefined &&
        (pricedLeg?.pricing?.vegas)[0]?.baseCurrency !== null
      "
    >
      {{ baseCurrency }}
      {{ (pricedLeg?.pricing?.vegas)[0]?.baseCurrency | number: '1.0-0' }}
    </div>
  </div>

  <div
    *ngIf="
      markUpExpanded && ('secondVega' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        isRowEnabled('secondVega') &&
        ('secondVega' | includedIn: extraResults) &&
        (pricedLeg?.pricing?.vegas)[1]?.baseCurrency !== null &&
        (pricedLeg?.pricing?.vegas)[1]?.baseCurrency !== undefined &&
        (pricedLeg?.pricing?.vegas)[1]?.baseCurrency !== ''
      "
    >
      {{ baseCurrency }}
      {{ (pricedLeg?.pricing?.vegas)[1]?.baseCurrency | number: '1.0-0' }}
    </div>
  </div>
  <div
    *ngIf="
      isRowEnabled('numeraire') &&
      markUpExpanded &&
      ('numeraire' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div class="center-text">
      {{ pricedLeg?.extraResults?.numeraire }}
    </div>
  </div>

  <div
    *ngIf="
      isRowEnabled('correlation') &&
      markUpExpanded &&
      ('correlation' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div class="center-text">
      {{ pricedLeg?.extraResults?.correlation | percent: '1.2-2' }}
    </div>
  </div>

  <div
    *ngIf="
      isRowEnabled('parStrike') &&
      markUpExpanded &&
      ('parStrike' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div class="center-text">
      {{ pricedLeg?.extraResults?.parStrike | percent: '1.2-2' }}
    </div>
  </div>

  <div
    *ngIf="
      isRowEnabled('events') &&
      markUpExpanded &&
      ('events' | extraAttributesFilter | lengthOfArray)
    "
    class="results-row"
  >
    <div class="center-text">
      <a
        role="tooltip"
        aria-haspopup="true"
        class="tooltip tooltip-sm tooltip-top-right"
      >
        <div class="event-info">
          <span class="event-info__text">
            {{ pricedLeg?.events }}
          </span>
        </div>
        <span class="tooltip-content">
          {{ pricedLeg?.events }}
        </span>
      </a>
    </div>
  </div>
</div>
